const uppercase = (value) => (typeof value === 'string' ? value.toUpperCase() : value);

export default uppercase;
